export default __webpack_public_path__ + "static/media/growingstudio.00c55628.svg";